if (!customElements.get('free-shipping-remaining')) {
  customElements.define(
    'free-shipping-remaining',
    class FreeShippingRemaining extends HTMLElement {
      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.update.bind(this));
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
      }

      update() {
        const thresholdCents = Number(this.dataset.freeShippingThresholdCents);
        if (!thresholdCents) return;

        fetch(`${window.routes.cart_url}.js`)
          .then((response) => response.json())
          .then((cart) => {
            const remainingCents = Math.max(thresholdCents - cart.total_price, 0);

            if (remainingCents <= 0) {
              this.innerHTML = this.dataset.freeShippingReachedHtml;
              return;
            }

            const amountFormatter = new Intl.NumberFormat(document.documentElement.lang, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
            let formattedAmount = amountFormatter.format(remainingCents / 100);
            const decimalSeparator =
              amountFormatter.formatToParts(1.1).find((part) => part.type === 'decimal')?.value || ',';
            if (formattedAmount.endsWith(`${decimalSeparator}00`)) {
              formattedAmount = formattedAmount.slice(0, -3);
            }

            const symbol = new Intl.NumberFormat(document.documentElement.lang, {
              style: 'currency',
              currency: cart.currency,
            })
              .formatToParts(0)
              .find((part) => part.type === 'currency')?.value;

            this.innerHTML = this.dataset.freeShippingRemainingTemplate.replace(
              '[[free_shipping_remaining]]',
              `${formattedAmount} ${symbol || cart.currency}`
            );
          })
          .catch((error) => console.error(error));
      }
    }
  );
}
